import { authConfig } from 'config/authConfig';
import {
  http,
  HttpRequestHeader,
  HttpGetRequestParams,
  HttpPostRequestParams,
  HttpDeleteRequestParams,
  HttpPutRequestParams,
  HttpPatchRequestParams,
  AuthService
} from '@exxonmobil/uit-uda-ui-components-lib';

export const getAuthToken = async () => {
  const isOnline = navigator.onLine;
  if (isOnline) {
    const authService = AuthService.getInstance(authConfig);
    return authService.getAuthToken();
  }
  return undefined;
};

export const defaultRequestHeaders = async (headers?: HttpRequestHeader) => {
  const authToken = await getAuthToken();
  const newHeaders: any = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...headers
  };
  if (authToken) {
    newHeaders.Authorization = `Bearer ${authToken}`;
  }
  return newHeaders;
};

const get = async (params: HttpGetRequestParams): Promise<Response> => {
  const headers = await defaultRequestHeaders(params.headers);
  return http.get({ ...params, headers });
};

const post = async (params: HttpPostRequestParams): Promise<Response> => {
  const headers = await defaultRequestHeaders(params.headers);
  return http.post({ ...params, headers });
};

const put = async (params: HttpPutRequestParams): Promise<Response> => {
  const headers = await defaultRequestHeaders(params.headers);
  return http.put({ ...params, headers });
};

const patch = async (params: HttpPatchRequestParams): Promise<Response> => {
  const headers = await defaultRequestHeaders(params.headers);
  return http.patch({ ...params, headers });
};

const del = async (params: HttpDeleteRequestParams): Promise<Response> => {
  const headers = await defaultRequestHeaders(params.headers);
  return http.del({ ...params, headers });
};

export const api = { get, post, put, patch, del };
